import { scopedApi } from '@/session/scopedClients';
import { GLOBAL_SCOPE, type RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams } from '@/types/apiQuery';
import { EndpointResponse } from '@/types/endpoints';
import type { IntegrationSubscription } from '@/types/integration';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'limit' | 'query'> & {
  all?: string | boolean;
};

export const getIntegrationSubscriptions = async (
  scope: RequestScope,
  params: RequestParams = {},
  options: ReadRequestOptions
): Promise<EndpointResponse<IntegrationSubscription[]>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<IntegrationSubscription[]>>('/integration_subscription', { ...options, params });
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};

export const getAdminIntegrationSubscriptions = async (
  params: Omit<RequestParams, 'all'> = {},
  options: ReadRequestOptions
): Promise<EndpointResponse<IntegrationSubscription[]>> => getIntegrationSubscriptions(GLOBAL_SCOPE, { ...params, all: 'true' }, options);

export const getStoreIntegrationSubscriptions = async (
  scope: RequestScope,
  options: ReadRequestOptions
): Promise<EndpointResponse<IntegrationSubscription[]>> => getIntegrationSubscriptions(scope, { limit: 1000 }, options);
